export default "__VITE_ASSET__1630de4b__"